const isValidNestedObject = (rawTokens) => {
    return (typeof rawTokens === 'object' &&
        !Array.isArray(rawTokens) &&
        rawTokens !== null);
};
export const getValue = (rawTokens, tokenName) => {
    const keys = tokenName.split('.');
    let current = rawTokens;
    for (const key of keys) {
        if (isValidNestedObject(current) && current?.hasOwnProperty(key)) {
            current = current[key];
        }
        else {
            return '';
        }
    }
    return current;
};
//# sourceMappingURL=get-value.js.map